<template>
  <div class="compare-card">
    <div class="compare-card-aside">
      <div class="count">
        {{ compare.images.length - 1 }}
        <v-icon small>$vuetify.icons.comparison</v-icon>
      </div>
      <v-btn class="btn-open flex-grow-1" icon width="100%" @click="viewCompare">
        <v-icon>$vuetify.icons.eye</v-icon>
      </v-btn>
      <delete-comparison-dialog @delete="deleteCompare" />
    </div>
    <div class="images-wrapper">
      <race-img
        height="224px"
        class="images-main"
        outlined
        :car-number="getCarNumber(mainCar)"
        :show-actions="false"
        :src="mainCar.thumbnail_url"
        :tags="getTags(mainCar)"
        :time="mainCar.created_time"
      />
      <div class="divider" />
      <race-img
        v-for="(car, i) in otherCars"
        height="224px"
        :car-number="getCarNumber(car)"
        :key="car._id + i"
        :show-actions="false"
        :src="car.thumbnail_url"
        :tags="getTags(car)"
        :time="car.created_time"
      />
    </div>
  </div>
</template>

<script>
  import { getImageTags } from '@/utils/helpers'
  import DeleteComparisonDialog from '@/components/dialogs/DeleteComparisonDialog'
  import RaceImg from '@/components/raceImageComponents/RaceImg';

  export default {
    components: {
      DeleteComparisonDialog,
      RaceImg,
    },
    name: "ComparisonCard",
    props: {
      compare: {
        type: Object,
        required: true,
      }
    },
    computed: {
      mainCar() {
        return this.compare?.images[0] || {}
      },
      otherCars() {
        return this.compare?.images?.filter((_, index) => index > 0) || []
      },
    },
    methods: {
      getCarNumber(img) {
        if (!img?.tags?.length) {
          return ''
        }
        return img.tags[0].car_number
      },
      getTags(img) {
        return getImageTags(img)
      },
      viewCompare() {
        this.$router.push({ name: 'compare', params: { compareId: this.compare.compare_id } })
      },
      deleteCompare() {
        this.$emit('removeCompare', this.compare?.compare_id)
      }
    }
  }
</script>

<style lang="scss" scoped>
.compare-card {
  width: fit-content;
  display: flex;
  gap: 10px;
  padding: 12px 12px 12px 8px;
  background-color: white;
  border: 1px solid var(--v-grey-lighten-2);
  border-radius: 6px 12px 12px 6px;
}

.compare-card-aside {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
  min-width: 40px;
  padding: 8px 0;
}

.count {
  padding-bottom: 10px;
  border-bottom: 1px solid var(--v-grey-lighten-1);
  color: var(--v-grey-darken-1);
  font-size: 14px;
  text-align: center;
}

.images-wrapper {
  display: grid;
  grid-template-columns: 340px 2px minmax(min-content, 340px);
  grid-auto-flow: column;
  grid-gap: 8px;
  align-items: center;
}

.images-main {
  margin-right: 2px;
}

.divider {
  height: 128px;
  width: 2px;
  margin: auto;
  background: var(--v-warning-base);
}

::v-deep {
  .btn-open {
    path {
      stroke: var(--v-grey-darken-1);
    }
  }
}
</style>
